import * as React from 'react';

import {convertToArray, safelyGetFilterByKey} from 'nutshell-core/filter';
import {deparam} from 'nutshell-core/routing/query-parameters';

import {ListView} from 'shells/list-view/list-view';

// @ts-expect-error
import {FunnelEmptyState} from './funnel-empty-state';
import {FunnelRow} from './funnel-row';
import type {StageInfo} from './funnel-row';

import styles from './funnel.module.css';

type Props = {
    funnel: StageInfo[];
    query: string;
};

export class Funnel extends React.Component<Props> {
    render() {
        return (
            <div className={styles.container}>
                <ListView
                    collection={this.props.funnel}
                    renderRow={this.renderRow}
                    specialStates={[
                        {
                            shouldRender: () =>
                                !this.props.funnel || this.props.funnel.length === 0,
                            component: <FunnelEmptyState isError={!this.props.funnel} />,
                        },
                    ]}
                />
            </div>
        );
    }

    renderRow = (stageInfo: StageInfo) => {
        const highestOpenLeadCount = this.props.funnel.reduce((prev, current) => {
            return Number(current.count) > prev ? Number(current.count) : prev;
        }, 0);

        let isFilteringOnHot = false;
        const params = deparam(this.props.query);
        if (params.filter) {
            const filterArray = convertToArray(params.filter);
            // If the filter exists, it's true
            if (safelyGetFilterByKey(filterArray, 'priority')) {
                isFilteringOnHot = true;
            }
        }

        return (
            <FunnelRow
                key={`${stageInfo.id}-${stageInfo.count}`}
                relativeHighestValue={highestOpenLeadCount}
                stageInfo={stageInfo}
                filterHot={isFilteringOnHot}
            />
        );
    };
}
